export const UPLOAD_MEDIA_REQUESTED = 'medialib/UPLOAD_REQUESTED';
export const UPLOAD_MEDIA_SUCCEED = 'medialib/UPLOAD_SUCCEED';
export const UPLOAD_MEDIA_FAILED = 'medialib/UPLOAD_FAILED';
